<template>
    <div class="mt-4">
        <div class="d-flex justify-content-between py-1">
            <div class="wfh-tab-header">Teams</div>
            <a href="/team-members/add-team/view" class="wfh-btn-link" v-if="isAdmin">
                <i class="fa fa-plus"></i>
                Add
            </a>
        </div>
        <teams-list></teams-list>
    </div>
</template>

<script>
    export default {
        computed: {
            isAdmin () {
                return this.$store.state.isAdmin
            },
        },
    }
</script>

<style scoped lang="scss">
    .wfh-btn-link {
        color: #303030;
        font-family: "Open Sans", sans-serif;
        font-size: 16px;
        font-weight: 600;
        letter-spacing: 0;
        line-height: 22px;

        i {
            margin: 0 4px;
            color: #0db4e6;
        }
    }
</style>
